import PropTypes from "prop-types"
import React from 'react'
import CardPendingReview from './cardPendingReview'
import CardFiled from './cardFiled'
import CardFreeSlot from './cardFreeSlot'
import { SituacaoComposicaoCarga } from '../../../../models/composicaoCarga/situacaoComposicaoCarga'
import * as S from './styled'
import CardInNegotiation from './cardInNegotiation'
import CardEmergencyNegotiation from './cardEmergencyNegotiation'

const Card = ({ data, hour, viewFreeSlot, viewScheduledDelivery,
  handleClickFree, handleOpenLoadForm, viewPendingReview, viewInNegotiation, viewEmergencyNegotiation,
  handleClickInNegotiation, isEditMode, handleSelectEditDate, dia, idCompositionSelected, selectedFreeSlot }) => (
  <S.WrapperAll>
    {viewScheduledDelivery &&
      <CardFiled
        handleClick={!isEditMode && handleOpenLoadForm}
        data={data.LoadCompositions.filter(x => x.Situation === SituacaoComposicaoCarga.Aceito)}
        hour={hour}
        dia={dia}
        idCompositionSelected={idCompositionSelected}
      />
    }
    {viewPendingReview &&
      <CardPendingReview
        handleClick={!isEditMode && handleOpenLoadForm}
        data={data.LoadCompositions.filter(x => x.Situation === SituacaoComposicaoCarga.AguardandoRevisaoFornecedor)}
        hour={hour}
        dia={dia}
        idCompositionSelected={idCompositionSelected}
      />
    }
    {viewInNegotiation &&
      <CardInNegotiation
        handleClick={!isEditMode && handleClickInNegotiation}
        data={data.LoadCompositions.filter(x => x.Situation === SituacaoComposicaoCarga.EmNegociacao)}
        hour={hour}
        dia={dia}
        idCompositionSelected={idCompositionSelected}
      />
    }
    {viewFreeSlot &&
      <CardFreeSlot
        handleClick={isEditMode ? handleSelectEditDate : handleClickFree}
        quantity={data.AvailableQuantity ? data.AvailableQuantity : 0}
        hour={hour}
        dia={dia}
        selectedFreeSlot={selectedFreeSlot}
      />
    }
    {viewEmergencyNegotiation &&
    <CardEmergencyNegotiation
      handleClick={!isEditMode && handleClickInNegotiation}
      data={data.LoadCompositions.filter(x => x.Situation === SituacaoComposicaoCarga.NegociacaoEmergencial)}
      hour={hour}
      dia={dia}
      idCompositionSelected={idCompositionSelected}
    />
    }
  </S.WrapperAll>
)

Card.propTypes = {
  data: PropTypes.shape({
    AvailableQuantity: PropTypes.any,
    LoadCompositions: PropTypes.shape({
      filter: PropTypes.func
    })
  }).isRequired,
  dia: PropTypes.any.isRequired,
  handleClickFree: PropTypes.any.isRequired,
  handleClickInNegotiation: PropTypes.any.isRequired,
  handleOpenLoadForm: PropTypes.any.isRequired,
  handleSelectEditDate: PropTypes.any.isRequired,
  hour: PropTypes.any.isRequired,
  idCompositionSelected: PropTypes.any.isRequired,
  isEditMode: PropTypes.any.isRequired,
  selectedFreeSlot: PropTypes.any.isRequired,
  viewEmergencyNegotiation: PropTypes.any.isRequired,
  viewFreeSlot: PropTypes.any.isRequired,
  viewInNegotiation: PropTypes.any.isRequired,
  viewPendingReview: PropTypes.any.isRequired,
  viewScheduledDelivery: PropTypes.any.isRequired
}

export default Card;

